import React from "react"
import styled from 'styled-components'
import constants from '~/style/constants'

const StyledInput = styled.input`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  border: 1px solid
    ${props =>
      props.error ? props.theme.colors.error : constants.colors.ui.borderGray};
  border-radius: 4px;
  outline: none;
  height: ${props => props.height ? props.height : '50px'};
  width: ${props => props.width ? props.width : '100%'};
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: 18px;
  text-indent: 9px;
  padding-top: 6px;
  margin-top: ${props => props.marginTop ? props.marginTop : '8px'};
  color: ${props => props.theme.colors.text.input};
  &::placeholder {
    color: ${props => props.theme.colors.text.inputPlaceholder};
  }
  caret-color: ${props => props.theme.colors.primary};
  &:focus {
    border: 1px solid rgba(0, 0, 0, 0);
    box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);
  }
`

const Input = ({onChange, value, ...props}) => {
  return (
    <StyledInput 
      onChange={onChange}
      value={value}
      {...props}
    />
  )
}

export default Input
